import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store/store";
import useAlerts from "../useAlerts";
import useModals from "../useModals";
import useLoading from "../useLoading";
import useApiErrorHandler from "../useApiErrorHandler";
import { addSubCategory, deactivateSubCategory, loadingSubCategories, loadingSubCategoriesDropdown, setSelectedCategory, updateSubCategory } from "../../store/slices/product/productSubCategorySlice";
import ProductSubCategoryService from "../../services/product/ProductSubCategoryService";

export const useProductSubCategories = () => {

    const dispatch: AppDispatch =
        useDispatch();

    const { show: showAlert } =
        useAlerts();

    const { openModal } =
        useModals();

    const {
        showLoadingIndicator,
        hideLoadingIndicator,
    } = useLoading();

    const { handle } =
        useApiErrorHandler();

    const {
        subCategories,
        subCategoriesDropdown,
        selectedCategoryId,
    } = useSelector(
        (state: RootState) =>
            state.productSubCategory
    );

    const loadSubCategoriesByCategory =
        async (
            categoryId: number
        ) => {

            try {

                showLoadingIndicator();

                dispatch(
                    setSelectedCategory(
                        categoryId
                    )
                );

                const response =
                    await ProductSubCategoryService
                        .getByCategory(
                            categoryId
                        );

                dispatch(
                    loadingSubCategories(
                        response
                    )
                );

            } catch (error) {

                handle(error);

            } finally {

                hideLoadingIndicator();
            }
        };

    const loadDropdown =
        async (
            categoryId: number
        ) => {

            try {

                const response =
                    await ProductSubCategoryService
                        .getDropdown(
                            categoryId
                        );

                dispatch(
                    loadingSubCategoriesDropdown(
                        response
                    )
                );

            } catch (error) {

                handle(error);
            }
        };

    const saveSubCategory =
        async (
            data: any
        ) => {

            try {

                if (!data.id) {

                    const response =
                        await ProductSubCategoryService
                            .save(data);

                    const {
                        title,
                        message,
                        type,
                        data: newSubCategory,
                    } = response;

                    if (newSubCategory) {

                        dispatch(
                            addSubCategory(
                                newSubCategory
                            )
                        );
                    }

                    openModal(
                        type,
                        {
                            title,
                            message,
                        }
                    );

                    return;
                }

                const response =
                    await ProductSubCategoryService
                        .update(
                            data.id,
                            data
                        );

                const {
                    title,
                    message,
                    type,
                    data: updatedSubCategory,
                } = response;

                if (updatedSubCategory) {

                    dispatch(
                        updateSubCategory(
                            updatedSubCategory
                        )
                    );
                }

                openModal(
                    type,
                    {
                        title,
                        message,
                    }
                );

            } catch (error) {

                handle(error);
            }
        };

    const toggleSubCategoryStatus =
        async (
            id: number
        ) => {

            try {

                const response =
                    await ProductSubCategoryService
                        .deactivate(id);

                showAlert(
                    response.type,
                    response.title,
                    response.message
                );

                dispatch(
                    deactivateSubCategory(
                        response.data
                    )
                );

            } catch (error) {

                handle(error);
            }
        };

    return {

        // State
        subCategories,
        subCategoriesDropdown,
        selectedCategoryId,

        // Loaders
        loadSubCategoriesByCategory,
        loadDropdown,

        // CRUD
        saveSubCategory,
        toggleSubCategoryStatus,
    };
};